// import moment from 'moment';
import { validateUrlPath, validateLongLat, validatePassword } from './regexValidator';

export const helperAdmin = {
  validateOperator: (operator) => {
    let error = {};
    const { name, image } = operator
    if (!name.trim()) error.name = 'Debe rellenar este campo';
    if (!image) error.image = 'Debe rellenar este campo';
    if (!validateUrlPath(image)) error.image = 'Debe colocar una url valida';
    return error;
  },
  validateUbication: (ubication) => {
    let error = {};
    const { name, address, lat, long } = ubication
    if (!name.trim()) error.name = 'Debe rellenar este campo';
    if (!address.trim()) error.address = 'Debe rellenar este campo';
    // if (!validateLongLat(long)) error.long = 'Ingrese una longitud valida';
    // if (!validateLongLat(lat)) error.lat = 'Ingrese una latitud valida'
    // if (!lat) error.lat = 'Debe rellenar este campo';
    // if (!long) error.long = 'Debe rellenar este campo';
    return error;
  },
  validatePlace: (place) => {
    let error = {};
    const { name, description } = place
    if (!name.trim()) error.name = 'Debe rellenar este campo';
    if (!description.trim()) error.description = 'Debe rellenar este campo';
    return error;
  },
  validateProfile: (profile) => {
    let error = {};
    const { title, name, description } = profile
    if (!title.trim()) error.title = 'Debe rellenar este campo';
    if (!name.trim()) error.name = 'Debe rellenar este campo';
    if (!description.trim()) error.description = 'Debe rellenar este campo';
    return error;
  },
  validateUser: (user) => {
    let error = {};
    const { name, password, profile, pickupPoint, profileSelected = {} } = user;
    const newPickups = Array.isArray(pickupPoint) ? [...pickupPoint] : [pickupPoint];
    if (!name.trim()) error.name = 'Debe rellenar este campo';
    if (!validatePassword(password)) error.password = 'Debe tener al menos 12 dígitos, Una letra mayúscula, Una letra minúscula , Un número y un carácter especial.';
    if (!profile.toString().trim()) error.profile = 'Debe rellenar este campo';
    if (['pickuppointop'].includes(profileSelected.name) && newPickups.length <= 0) error.pickupPoint = 'Debe rellenar este campo';
    return error;
  },
  validateUserChangePassword: (user) => {
    let error = {};
    const { password = {} } = user;
    if (!validatePassword(password)) error.password = 'Debe tener al menos 12 dígitos, Una letra mayúscula, Una letra minúscula , Un número y un carácter especial.';
    return error;
  },
  supportExcelFiles: ['xlsx', 'xls'],
  removeKey: (key, { [key]: _, ...rest }) => rest,
  verifySize: async (url) => {
    const img = await helperAdmin.getMeta(url);
    if (img.width === 533 && img.height === 140) return true;
    else return false
  },
  getMeta: (url) => new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.addEventListener("load", function () {
      resolve(img);
    });
  }),
  imageToDataFromUrl: async url => {
    if (!url.includes('blob')) return null;
    const response = await fetch(url);
    const blob = await response.blob();
    const imageBase64 = await helperAdmin.getBase64(blob);
    return imageBase64;
  },
  getBase64: (file, cb) => new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve(reader.result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
      reject(error)
    };
  }),
  isBeforeToday: (date) => {
    if (date < new Date()) return true;
    else return false
  },
  isDateHasBegun: (date) => {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date <= today) return true;
    return false
  }
}

export default helperAdmin;
